import './ratingsBlob.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/RatingsBlob/index.js